var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_670_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06733 15.794V10.474H4.418V8.02934H6.06733V6.976C6.06733 4.25267 7.29933 2.99067 9.97267 2.99067C10.24 2.99067 10.6093 3.01867 10.9513 3.05934C11.2075 3.08569 11.4616 3.12912 11.712 3.18933V5.406C11.5672 5.3925 11.422 5.38449 11.2767 5.382C11.1138 5.37777 10.9509 5.37577 10.788 5.376C10.3167 5.376 9.94867 5.44 9.67133 5.582C9.48489 5.67554 9.32816 5.81912 9.21867 5.99667C9.04667 6.27667 8.96933 6.66 8.96933 7.16467V8.02934H11.582L11.3247 9.43134L11.1333 10.474H8.96933V15.9707C12.9307 15.492 16 12.1193 16 8.02934C16 3.61134 12.418 0.029335 8 0.029335C3.582 0.029335 0 3.61134 0 8.02934C0 11.7813 2.58267 14.9293 6.06733 15.794Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_670_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.09fb19fbe015c391efbb9b87833a9c12.svg";
export { ForwardRef as ReactComponent };